import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";
import SuiInput from "components/SuiInput";
import DraggableDialog from "components/UpStyled/DraggableDialog";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckIcon from "@mui/icons-material/Check";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PeopleIcon from "@mui/icons-material/People";
import FolderIcon from "@mui/icons-material/Folder";

import { Divider } from "antd";

import api from "services/api";

import { AccountContext } from "context/account";
import { StoreContext } from "context/store";
import AvatarComplex from "pages/de/share-page/components/AvatarComplex";

import { filterParser } from "utils/helper";
import { privilegeOptions } from "utils/data";
import { toast } from "react-hot-toast";
import colors from "assets/theme/base/colors";
import { keyframes } from "@emotion/react";
import pxToRem from "assets/theme/functions/pxToRem";
import typography from "assets/theme/base/typography";
import Prompt from "components/UpStyled/Prompt";

const ShareListModal = ({
  item,
  type,
  handleClose,
  handleOpen,
  handleOk,
  visible,
  handleRefresh = () => {},
  permittedUsers = [],
  permittedCollectionUsers = [],
}) => {
  const { size, fontWeightRegular } = typography;

  const [searchName, setSearchname] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [sentStatus, setSentStatus] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState({});
  const [ownerStore, setOwnerStore] = useState({});
  const [inputEmailValue, setInputEmailValue] = useState("");
  const [confirmShareVisible, setConfirmShareVisible] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState(privilegeOptions[0]);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [collectionSelectedPermission, setCollectionSelectedPermission] = useState(
    privilegeOptions[0]
  );

  let refinedPermissionOptions = privilegeOptions.filter((x) => x.value != 0);

  const open = Boolean(anchorEl);
  const inputRef = useRef(null);

  const account = useContext(AccountContext);
  const { store } = useContext(StoreContext);

  useEffect(() => {
    handleRetrieveUsers();
    retrieveOwner();
  }, []);

  const handleSelectCollaboratorChange = (record) => {
    setSelectedUsers([record]);
    setConfirmShareVisible(true);
  };

  const handleConfirmShare = () => {
    if (selectedUsers.length > 0) {
      const payload = selectedUsers.map((x) => ({
        email: x.value,
        resource_id: item.id,
        resource_type: type,
        privilege: selectedPermission.value,
      }));
      //console.log(payload);
      handleAddPermission(payload);
      setConfirmShareVisible(false);
    } else {
      toast.error("Please select at least one user!");
    }
  };

  const handleAddPermission = async (payload) => {
    // if (type == "collection") {
    //   updateColectionContent(record);
    // }

    let message = `${payload.length} collaborators`;
    if (payload.length == 1) {
      message = payload[0].label;
    }
    try {
      await api.resourcePermission.grant({ permissions: payload });
      toast.success(`Your ${type} has been shared successfully!`);
      handleRefresh();
    } catch (err) {
      console.log(err);
      toast.error(`Your ${type} could not be shared!`);
    }
  };

  //share all products and moodboards for collection
  const updateColectionContent = async (record, privilege = 1) => {
    if (type != "collection") {
      return;
    }
    let products = item?.products || [];
    let payload = [];
    //share products
    for (let i = 0; i < products.length; i++) {
      let temp = {
        email: record.value,
        resource_id: products[i].id,
        resource_type: "product",
        privilege: privilege,
      };
      payload.push(temp);
    }

    try {
      //retrieve moodboards for collection
      let myMoodboards = item.moodboard || [];
      for (let i = 0; i < myMoodboards.length; i++) {
        let temp = {
          email: record.value,
          resource_id: myMoodboards[i].moodboard_id,
          resource_type: "moodboard",
          privilege: privilege,
        };
        payload.push(temp);
      }

      if (privilege == 0) {
        await api.resourcePermission.revoke({ permissions: payload }); //remove permissions if privileges=0
      } else {
        await api.resourcePermission.grant({ permissions: payload });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleRetrieveUsers = async (q = "") => {
    try {
      let payload = {
        sort: ["account_status:asc", "profile_update_level:desc"],
        offset: 0,
        limit: 2000,
      };
      payload["q"] = q;
      let myFilter = {};

      if (type == "product") {
        const owner_id = item?.store?.owner_id;
        myFilter["id"] = { neq: [owner_id, "AllDesigners"] };
      } else if (type == "collection") {
        const owner_id = item?.store_id;
        myFilter["id"] = { neq: [owner_id, "AllDesigners"] };
      } else if (type == "moodboard") {
        const owner_id = item?.owner_id;
        myFilter["id"] = { neq: [owner_id, "AllDesigners"] };
      } else if (type == "size_chart" || type == "calendar" || type == "event") {
        const owner_id = item?.owner_id;
        myFilter["id"] = { neq: [owner_id, "AllDesigners"] };
      }

      const newFilterStr = filterParser(myFilter);
      if (newFilterStr) {
        payload["filter"] = newFilterStr;
      }
      const { data } = await api.users.search(payload);
      const userList = data?.hits || [];
      let options = [];
      for (let i = 0; i < userList.length; i++) {
        const store = userList[i]?.stores[0];
        let record = {
          label: store.name,
          value: userList[i].email,
          description: userList[i].email,
        };
        options.push(record);
      }

      setUserOptions(options);
    } catch (err) {
      console.log(err);
      toast.error("Retrieve user list failed!");
    }
  };

  const retrieveOwner = async () => {
    try {
      console.log(type);
      if (type == "product") {
        console.log(item);
        if (item?.store) {
          setOwnerStore(item.store);
        } else {
          const { data } = await api.account.get(item?.store_id);
          setOwnerStore(data?.user?.stores?.[0]);
        }
      } else if (type == "collection") {
        const { data } = await api.account.get(item?.store_id);
        setOwnerStore(data?.user?.stores?.[0]);
      } else if (type == "moodboard") {
        const { data } = await api.account.get(item?.owner_id);
        setOwnerStore(data?.user?.stores?.[0]);
      } else if (type == "size_chart" || type == "calendar" || type == "event") {
        const { data } = await api.account.get(item?.owner_id);
        setOwnerStore(data?.user?.stores?.[0]);
      }
    } catch (err) {
      toast.error("Retrieve owner info failed");
      console.log(err);
    }
  };

  const handleSendEmail = async () => {
    if (!inputEmailValue) {
      return toast.error("Please input an email address!");
    }
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (inputEmailValue.match(mailformat)) {
      const payload = [
        {
          email: inputEmailValue,
          resource_id: item.id,
          resource_type: type,
        },
      ];
      await handleAddPermission(payload);
      setSentStatus("success");
    } else {
      setSentStatus("error");
      toast.error("Not a valid email address!");
    }
  };

  const handleEmailChange = (e) => {
    let email = e?.target.value;
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    setInputEmailValue(email);
    if (email.match(mailformat)) {
      setSentStatus("success");
    } else {
      setSentStatus("error");
    }
  };

  const formatEmailSentStatus = () => {
    if (sentStatus == "success") {
      return <CheckCircleOutlineIcon color="success" fontSize="small" />;
    } else if (sentStatus == "error") {
      return <HighlightOffIcon color="error" fontSize="small" />;
    } else {
      return <div />;
    }
  };

  const handleShareItem = () => {
    handleClose();
    handleRefresh();
  };

  const handleClickListItem = (e, user) => {
    setSelectedUser(user);
    setAnchorEl(e.currentTarget);
  };

  const handleUpdatePermission = async (event, value, newType) => {
    const email = selectedUser?.user?.email;
    const storeName = selectedUser?.user?.stores?.[0]?.name;
    const permissionType = newType ? newType : type;

    const resourceId = selectedUser.resource_id || item.id;

    let payload = [
      {
        email: email,
        resource_id: resourceId,
        resource_type: permissionType,
        privilege: value,
      },
    ];
    try {
      if (value == 0) {
        payload = [
          {
            user_id: selectedUser?.user_id,
            resource_id: resourceId,
            resource_type: permissionType,
          },
        ];
        await api.resourcePermission.revoke({ permissions: payload }); //remove permissions if privileges=0
      } else {
        await api.resourcePermission.grant({ permissions: payload });
      }
      // if (type == "collection") {
      //   updateColectionContent({ value: email, label: email }, value);
      // }

      toast.success(`Your privileges for ${storeName || email} have been updated successfully!`);

      handleRefresh();
      setAnchorEl(null);
    } catch (err) {
      console.log(err);
      toast.error(`Your privileges for ${storeName || email} could not be updated!`);
    }
  };

  const PermissionMenu = () => (
    <Menu
      id="permission-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
      MenuListProps={{
        "aria-labelledby": "lock-button",
        role: "listbox",
      }}
    >
      {privilegeOptions.map((option, index) => (
        <MenuItem
          key={option.value}
          onClick={(e) => {
            setAnchorEl(null);
            if (selectedUser.resource_type == "collection") {
              setConfirmVisible(true);
              setCollectionSelectedPermission(option.value);
            } else {
              handleUpdatePermission(e, option.value);
            }
          }}
        >
          <SuiBox display="flex" alignItems="center" justifyContent="center">
            <SuiBox sx={{ width: 30 }}>
              {selectedUser.privilege == option.value ? (
                <CheckIcon fontSize="small" color="success" />
              ) : null}
            </SuiBox>
          </SuiBox>
          <SuiBox>{option.label}</SuiBox>
        </MenuItem>
      ))}
    </Menu>
  );

  const CustomOption = (data) => {
    return !data.isDisabled ? (
      <SuiBox
        {...data.innerProps}
        sx={{
          position: "relative",
          minWidth: pxToRem(60),
          minHeight: "unset",
          padding: `${pxToRem(4.8)} ${pxToRem(8)} ${pxToRem(4.8)} ${pxToRem(8)}`,
          //padding: `${pxToRem(4.8)} ${pxToRem(100)} ${pxToRem(4.8)} ${pxToRem(16)}`,
          borderRadius: ({ borders: { borderRadius } }) => borderRadius.md,
          fontSize: size.sm,
          color: colors.text.main,
          cursor: data.isDisabled ? "not-allowed" : "pointer",
          opacity: data.isDisabled ? 0.5 : 1,
          userSelect: data.isDisabled ? "none" : "auto",
          transition: "background-color 300ms ease, color 300ms ease",

          "&:after": {
            content: "''",
            display: "block",
            fontSize: size.xs,
            position: "absolute",
            right: pxToRem(10),
            top: "52%",
            color: colors.text.main,
            opacity: 0,
            transform: "translateY(-50%)",
            transition: "opacity 300ms ease",
          },

          "&:hover, &:focus": {
            backgroundColor: data.isDisabled ? colors.transparent.main : colors.light.main,
            color: data.isDisabled ? "currentColor" : colors.dark.main,

            "&:after": {
              content: data.isDisabled && "''",
              opacity: 0.5,
            },
          },
        }}
      >
        <SuiBox>{data?.data?.label}</SuiBox>
        <SuiTypography variant="label" color="text">
          {data?.data?.description}
        </SuiTypography>
      </SuiBox>
    ) : null;
  };

  const ConfirmShareComponent = () => (
    <SuiBox pt={0.5}>
      <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
        <SuiBox sx={{ width: "100%", color: "white" }}>
          <SuiSelect
            isSearchable
            onChange={(rec) => {
              setSelectedUsers(rec);
              if (rec.length == 0) {
                setConfirmShareVisible(false);
              }
            }}
            isClearable={false}
            options={userOptions}
            isMulti
            value={selectedUsers}
            sx={{
              dropdownIndicator: { display: "none", padding: 0 },
              valueContainer: { maxHeight: 120, overflow: "auto", color: "white" },
            }}
            components={{ Option: CustomOption }}
          />
        </SuiBox>
        <SuiBox sx={{ width: 110 }}>
          <SuiSelect
            onChange={(rec) => {
              setSelectedPermission(rec);
            }}
            options={refinedPermissionOptions}
            value={selectedPermission}
          />{" "}
        </SuiBox>
      </SuiBox>
      {selectedUsers.length > 0 ? (
        <SuiBox mt={1} ml={0.5} display="flex" itemsAlign="center" gap={1}>
          <PeopleIcon fontSize="small" color="text" />
          <SuiTypography component="label" variant="body1" textTransform="none" color="text">
            {selectedUsers.length} users have been selected
          </SuiTypography>{" "}
        </SuiBox>
      ) : null}
    </SuiBox>
  );

  return (
    <DraggableDialog
      heading={`Share "${item?.title || item?.name || item?.label}"`}
      text={
        confirmShareVisible ? (
          <ConfirmShareComponent />
        ) : (
          <SuiBox pt={0.5}>
            <SuiSelect
              isSearchable
              onChange={handleSelectCollaboratorChange}
              options={userOptions}
              components={{ Option: CustomOption }}
            />
            <SuiBox mt={1} display="inline-block">
              <SuiTypography
                component="label"
                variant="body1"
                fontWeight="bold"
                textTransform="none"
              >
                People with access
              </SuiTypography>
            </SuiBox>
            <List
              sx={{ width: "100%", maxHeight: 360, overflow: "auto", bgcolor: "background.paper" }}
            >
              <ListItemButton alignItems="flex-start">
                <ListItem
                  alignItems="center"
                  secondaryAction={
                    <SuiButton variant="text" color="dark" disabled>
                      Owner
                    </SuiButton>
                  }
                >
                  <ListItemAvatar>
                    <AvatarComplex
                      store={ownerStore}
                      size="lg"
                      onAvatarClick={null}
                      sharedSessions={null}
                      iconColor="white"
                      isOwner={true}
                    />
                  </ListItemAvatar>
                  <ListItemText primary={ownerStore?.name + "(you)"} />
                </ListItem>
              </ListItemButton>
              {permittedUsers.map((user, index) => {
                const permission = privilegeOptions.find((x) => x.value == user?.privilege);
                const email = user?.user?.email;
                const store =
                  user?.user?.stores && user?.user?.stores.length > 0 ? user?.user?.stores[0] : {};

                return (
                  <ListItemButton alignItems="flex-start" key={index}>
                    <ListItem
                      secondaryAction={
                        <SuiButton
                          variant="text"
                          color="dark"
                          onClick={(e) => handleClickListItem(e, user)}
                        >
                          {permission?.label}
                          <ArrowDropDownIcon fontSize="sm" />
                        </SuiButton>
                      }
                    >
                      <ListItemAvatar>
                        <AvatarComplex
                          store={store}
                          size="lg"
                          onAvatarClick={null}
                          sharedSessions={null}
                          iconColor="white"
                          icon={
                            user?.resource_type == "collection" ? (
                              <FolderIcon sx={{ width: 16, height: 16 }} color="info" />
                            ) : null
                          }
                        />
                      </ListItemAvatar>
                      <ListItemText
                        primary={user?.user?.account_status == "active" ? store?.name : email}
                        secondary={
                          <React.Fragment>
                            <SuiTypography
                              sx={{ display: "inline" }}
                              component="span"
                              variant="body2"
                              color="text.primary"
                            >
                              {user?.user?.account_status == "active" ? email : "Pending..."}
                            </SuiTypography>
                          </React.Fragment>
                        }
                      />{" "}
                    </ListItem>
                  </ListItemButton>
                );
              })}
            </List>
            <Divider style={{ margin: "4px 0px" }} />

            {permittedCollectionUsers.length > 0 && type != "collection" ? (
              <SuiBox pl={2}>
                <SuiBox mt={0.5} display="inline-block">
                  <SuiTypography
                    component="label"
                    variant="body2"
                    fontWeight="bold"
                    textTransform="none"
                  >
                    Permission granted through collection
                  </SuiTypography>
                </SuiBox>
                <List
                  sx={{
                    width: "100%",
                    maxHeight: 360,
                    overflow: "auto",
                    bgcolor: "background.paper",
                  }}
                >
                  {permittedCollectionUsers.map((user, index) => {
                    const permission = privilegeOptions.find((x) => x.value == user?.privilege);
                    const email = user?.user?.email;
                    const store =
                      user?.user?.stores && user?.user?.stores.length > 0
                        ? user?.user?.stores[0]
                        : {};

                    return (
                      <ListItemButton alignItems="flex-start" key={index}>
                        <ListItem
                          secondaryAction={
                            <SuiButton
                              variant="text"
                              color="dark"
                              onClick={(e) => handleClickListItem(e, user, "collection")}
                            >
                              {permission?.label}
                              <ArrowDropDownIcon fontSize="sm" />
                            </SuiButton>
                          }
                        >
                          <ListItemAvatar>
                            <AvatarComplex
                              store={store}
                              size="lg"
                              onAvatarClick={null}
                              sharedSessions={null}
                              iconColor="white"
                              icon={<FolderIcon sx={{ width: 16, height: 16 }} color="info" />}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={store?.name}
                            secondary={
                              <React.Fragment>
                                <SuiTypography
                                  sx={{ display: "inline" }}
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  {email}
                                </SuiTypography>
                              </React.Fragment>
                            }
                          />{" "}
                        </ListItem>
                      </ListItemButton>
                    );
                  })}
                </List>
                <Divider style={{ margin: "12px 0px" }} />
              </SuiBox>
            ) : null}

            <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
              <SuiBox display="inline-block">
                <SuiTypography
                  component="label"
                  variant="body1"
                  fontWeight="bold"
                  textTransform="none"
                >
                  Invite via Email
                </SuiTypography>
              </SuiBox>
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                <SuiInput
                  type="email"
                  placeholder="Email"
                  onChange={handleEmailChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSendEmail(e);
                    }
                  }}
                  icon={{ component: formatEmailSentStatus(), direction: "right" }}
                />
                <SuiButton color="light" onClick={handleSendEmail}>
                  Invite
                </SuiButton>
              </SuiBox>
            </SuiBox>
            <PermissionMenu />
            {confirmVisible ? (
              <Prompt
                heading="Change Collection Permission"
                text={
                  <SuiBox>
                    This content is shared through a collection, Are you sure to change the whole{" "}
                    <strong>collection</strong> permission?
                  </SuiBox>
                }
                visible={confirmVisible}
                okText="Update"
                handleOk={(e) => {
                  handleUpdatePermission(e, collectionSelectedPermission, "collection");
                  setConfirmVisible(false);
                }}
                handleClose={() => setConfirmVisible(false)}
              />
            ) : null}
          </SuiBox>
        )
      }
      visible={visible}
      handleClose={
        confirmShareVisible
          ? () => {
              setConfirmShareVisible(false);
            }
          : handleClose
      }
      handleOk={
        confirmShareVisible
          ? () => {
              handleConfirmShare();
              setConfirmShareVisible(false);
            }
          : () => {
              handleRefresh();
              handleClose();
            }
      }
      okText={confirmShareVisible ? "Share" : "Done"}
      cancelText={confirmShareVisible ? "Cancel" : null}
      hideAction={false}
      option={{ fullWidth: true, maxWidth: "sm" }}
    />
  );
};

export default ShareListModal;
